import {
  Button as ButtonAntd,
  Col as ColAntd,
  DatePicker as DatePickerAntd,
  Form as FormAntd,
  Input as InputAntd,
  Row as RowAntd,
  Table as TableAntd,
} from 'antd';
import styled from 'styled-components';

export const Texto = styled.span`
  font-size: 14px;
`;

export const Status = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 1em;

  @media (min-width: 700px) and (max-width: 1324px) {
    justify-content: space-between;
    padding-top: 10px;
  }
`;

export const StatusItem = styled(ColAntd)`
  @media (min-width: 700px) and (max-width: 1324px) {
    display: block;
    -ms-flex: 0 0 65.5%;
    flex: 0 0 65.5%;
    max-width: 65.5%;
  }
`;

export const Divider = styled(ColAntd)`
  width: 15px;
  min-width: 15px;
  margin: 12px 12px 12px 0;
  background: #74aa49;

  @media (min-width: 700px) and (max-width: 1324px) {
    display: none;
  }
`;

export const Item = styled.div`
  font-size: 12px;
  color: #fff;
  padding: 2px;
  background-color: ${props => props.color};
  border-color: rgba(0, 0, 0, 0);
  border-radius: 3px;
  margin-left: 10px;
  width: 45px;
  height: 24px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const LinhaStatusEsquerda = styled.div`
  display: flex;
  margin: 20px 0px 50px;
  justify-content: start;
  background: #ffffff;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
  box-sizing: border-box;
  padding: 5px 0px 5px 0px;
`;

export const LinhaStatusDireita = styled.div`
  display: flex;
  margin: 20px 0px 50px;
  justify-content: flex-end;
  background: #ffffff;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
  box-sizing: border-box;
  padding: 5px 0px 5px 0px;

  @media (min-width: 700px) and (max-width: 1324px) {
    .ant-col {
      display: block;
      -ms-flex: 0 0 70%;
      flex: 0 0 70%;
      max-width: 70%;
    }
  }
`;

export const Content = styled(RowAntd)`
  padding: 20px;
`;

export const EditarButton = styled(ButtonAntd)`
  padding: 0;
  color: #6bbc60;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;

  &:hover {
    color: #6bbc60;
  }
`;

export const Table = styled(TableAntd)`
  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table table {
    table-layout: fixed !important;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 11px;
    background: #f5f5f6;
  }

  .ant-table-tbody > tr > td {
    padding: ${props => props.colpadding || '0px 8px'};
    font-size: 11px;
    border: 1px solid #e5e5e5;
  }

  .ant-table-cell:last-child {
    text-align: center;
  }
`;

export const FiltroInput = styled(InputAntd)`
  width: 188px;
  margin-bottom: 8px;
  display: block;

  .ant-table-filter-trigger-container {
    position: relative;
  }
`;

export const Title = styled.span`
  font-weight: bold;
  display: block;
`;

export const SubTitle = styled.span`
  display: block;
`;

export const Label = styled.span`
  display: block;
  color: #4f4f4f;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  margin-top: 4px;
`;

export const Text = styled.span``;

export const Form = styled(FormAntd)`
  align-items: baseline !important;
`;

export const DatePicker = styled(DatePickerAntd)`
  width: 100%;
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  border: 1px solid ${props => props.color};
  border-radius: 4px !important;
  box-sizing: border-box;
  margin-right: 8px;
  background: ${props => props.color};
  color: #fff;

  :hover {
    color: ${props => props.color};
    border: 1px solid ${props => props.color};
  }
`;
